export const SELECT_CREDITOR = 'SELECT_CREDITOR';
//# sourceMappingURL=actionTypes.js.map